<template>
  <ax-dialog 
    ref="dialog"
    title="Filter Wells" 
    icon="mdi-filter-outline" 
    tooltip="Filter wells" 
    size="medium" 
    @submitted="onSubmit"
  >
    <template slot="content">
      <v-tabs vertical v-model="tab">
        <template v-for="(filter, column, f) in filters.options">
          <v-tab :key="f" :href="`#${column}`" class="justify-start">
            <v-checkbox v-model="filter.enabled"></v-checkbox>
            {{ column }}
          </v-tab>
          <v-tab-item :key="f" :value="column">
            <v-card-text>
              <v-autocomplete
                v-if="['object','datetime64[ns]'].includes(filter.type)"
                v-model="filter.selected"
                :items="filter.list.filter(o => o)"
                label="Select"
                placeholder="Select"
                multiple
              ></v-autocomplete>
              <v-range-slider
                v-else
                class="align-center"
                v-model="filter.selected"
                :min="filter.min"
                :max="filter.max"
              >
              <template v-slot:prepend>
                <v-text-field
                  :value="filter.selected[0]"
                  class="mt-0 pt-0"
                  single-line hint="Min" persistent-hint
                  type="number"
                  @change="$set(filter.selected, 0, $event)"
                ></v-text-field>
              </template>
              <template v-slot:append>
                <v-text-field
                  :value="filter.selected[1]"
                  class="mt-0 pt-0"
                  single-line hint="Max" persistent-hint
                  type="number"
                  @change="$set(filter.selected, 1, $event)"
                ></v-text-field>
              </template>
              </v-range-slider>
            </v-card-text>
          </v-tab-item>
        </template>
      </v-tabs>
    </template>
    <template slot="footer_prefix">
      <v-checkbox class="ml-2" v-model="all" :label="`Select wells that match ${all ? 'ALL' : 'ANY'} conditions`"></v-checkbox>
    </template>
    <template slot="submit_text">Filter</template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgFilterWells",
  props: {
    filters: { type: Object, required: true }
  },
  components: {
    AxDialog
  },
  data() {
    return {
      tab: null,
      all: false
    }
  },
  methods: {
    onSubmit() {
      this.$refs.dialog.show = false
      this.$emit('submitted', this.filters)
    }
  }
}
</script>